import type { ReactNode } from 'react';
import { FollowSelectorContextProvider } from '../context/FollowSelectorContext';

interface FollowSelectorProviderProps {
    children: ReactNode;
}

/**
 * Global provider for the FollowSelector.
 * Provides context for popover instances rendered locally in TileFollowButtonWithPopover.
 * Place this in the app root to enable the board selector functionality.
 */
export const FollowSelectorProvider = ({
    children,
}: FollowSelectorProviderProps) => {
    return (
        <FollowSelectorContextProvider>
            {children}
        </FollowSelectorContextProvider>
    );
};
